import React, { useContext, useEffect, useState} from "react";
import { Container, Button } from '@mui/material';
import MenuAppBar from '../components/MenuAppBar';
import MenuBottAppBar from '../components/MenuBottAppBar';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import axios from "axios";

const EnergieEntitaGrafRok = () => {
  const { logout, role } = useContext(AuthContext);
  const navigate = useNavigate();

  const [roky, setRoky] = useState([]);
  const [actrok, setActrok] = useState((new Date()).getFullYear().toString());
  const [data, setData] = useState([]);
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  };
  
  const formatStackColumn1 = function() {
        
    let thisPoint = this.point,
        allSeries = this.series.chart.series,
        stackName = this.series.userOptions.name,
        thisIndex = thisPoint.index,
        returnString = '<table class="tooltipJZ" style="width:200px;font-size: 11px;"><tr><td colspan="2"><b>' + this.key + '</b></td></tr>';
        
    allSeries.sort(function (a, b) {
      return b.data[thisIndex].y - a.data[thisIndex].y;
    });
    allSeries.forEach(function(ser) {
      
      //if (ser.options.stack === thisPoint.series.options.stack)
      if (stackName == ser.name && ser.visible) {
        returnString += '<tr style="background-color:'+ser.color+';color:white"><td><b>'+ser.name + '</b></td><td><b>' + ser.points[thisIndex].y + '</b></td></tr>';
      } else if (ser.visible) {
        returnString += '<tr><td>'+ser.name + '</td><td>' + ser.points[thisIndex].y + '</td></tr>';
      }
    
    });
      

    returnString += '<tr><td><b>Součet</b></td><td><b>' + this.point.stackTotal+'</b></td><tr></table>';

    return returnString;
  }
  const formatStackColumn3 = function() {
        
    let thisPoint = this.point,
        allSeries = this.series.chart.series,
        stackName = this.series.userOptions.name,
        thisIndex = thisPoint.index,
        returnString = '<table class="tooltipJZ" style="width:200px;font-size: 11px;"><tr><td colspan="2"><b>' + this.key + '</b></td></tr>',
        total = 0;
        
    allSeries.sort(function (a, b) {
      return b.data[thisIndex].y - a.data[thisIndex].y;
    });
    allSeries.forEach(function(ser) {
      
      //if (ser.options.stack === thisPoint.series.options.stack)
      if (stackName == ser.name && ser.visible) {
        returnString += '<tr style="background-color:'+ser.color+';color:white"><td><b>'+ser.name + '</b></td><td><b>' + ser.points[thisIndex].y + '</b></td></tr>';
      } else if (ser.visible) {
        returnString += '<tr><td>'+ser.name + '</td><td>' + ser.points[thisIndex].y + '</td></tr>';
      }
      total += parseFloat(ser.points[thisIndex].y);

    
    });
      

    returnString += '<tr><td><b>Součet</b></td><td><b>' + total.toFixed(2)+'</b></td><tr></table>';

    return returnString;
  }
  
  const loadData = async (rok) => {


    const data0 = await axios.get("/api/energie/roky", { headers: getAuthHeaders(), params:{}});
    const roky = [];
    data0.data.forEach(element => {
      roky.push(element.rok);
    });
    setRoky(roky);

    const data1 = await axios.get("/api/energie/graf", { headers: getAuthHeaders(), params:{"kod": "entitarok1", "rok":rok}});
    data1.data.series.sort((a, b) => (a.data[0] > b.data[0]) ? 1 : -1);
    const data2 = await axios.get("/api/energie/graf", { headers: getAuthHeaders(), params:{"kod": "entitarok2", "rok":rok}});
    const data3 = await axios.get("/api/energie/graf", { headers: getAuthHeaders(), params:{"kod": "entitarok3", "rok":rok}});
    
    data1.data.tooltip.useHTML = true;
    data1.data.tooltip.formatter = formatStackColumn1;

    data3.data.tooltip.useHTML = true;
    data3.data.tooltip.formatter = formatStackColumn3;

    setData([data3.data, data1.data,data2.data]);
    setLoading(false);


  };
  
  useEffect(() => {

    loadData(actrok);

    

  }, []);

  
  if (loading) return <Box sx={{ width: '100%' }}><LinearProgress /></Box>;
  if (error) return <p>Chyba: {error}</p>;

  //return <HighchartsReact highcharts={Highcharts} options={data[0]} />;
  
  return (
    <Container>
          <MenuAppBar title='Energie - Roční grafy entity' />
        
          {
            roky.map((rok, index) => (
              
              <Button variant={(rok==actrok) ? 'contained':'outlined'} color={(rok==actrok) ? 'success' : 'primary'} key={'rok-'+index} onClick={() => {
                setActrok(rok);
                loadData(rok);
                            
              }}>{rok}</Button>
            ))
          }
          {data.map((data, index) => (
            <HighchartsReact containerProps={{ style: { height: "600px" } }} highcharts={Highcharts} options={data} key={'graf-'+index}/>
          ))}
          
      <MenuBottAppBar value={'Energie'} />
    </Container>
  );
};

export default EnergieEntitaGrafRok;
